import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Poll/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './Poll.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const PollViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="poll"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
PollViewer.displayName = 'PollViewer';

export default PollViewer;
